import moment from 'moment';

import beGetCashup from 'actions/cashup/beGetCashup.action';
import beGetReconcile from 'actions/cashup/beGetReconcile.action';
import beListReconcile from 'actions/cashup/beListReconcile.action';
import logger from 'utils/logger.util';
import isFn from 'utils/predicates/function/isFn.util';

const L = logger('beCashupAndReconcile');

const determineBeCashup = (options) => {
  const beCashup = options?.beCashup;
  if (isFn(beCashup)) return beCashup;

  L.warn('determineBeCashup()', 'Missing beCashup in options:', options);
  return beGetCashup;
};

const beCashupAndReconcile = (options) => async (dispatch) => {
  try {
    const { begin, end, desc, pageNumber } = options ?? {};
    const beCashup = determineBeCashup(options);

    const action = beCashup({ begin, end, desc, pageNumber });
    const dispatchResult = await dispatch(action);

    if (!dispatchResult.is.ok) return void 1;

    const isShorterThanDay = moment(end).diff(moment(begin), 'd') < 1;

    return isShorterThanDay
      ? dispatch(beGetReconcile({ day: begin, desc, pageNumber }))
      : dispatch(beListReconcile({ begin, end, desc, pageNumber }));
  } catch (e) {
    throw L.warn('()', e);
  }
};

export default beCashupAndReconcile;
